import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const TimeIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.5858 13C11.2107 12.6249 11 12.1162 11 11.5858V7H13V11.5858L16.2071 14.7929L14.7929 16.2071L11.5858 13Z'
      fill={color} />
    <path fillRule='evenodd' clipRule='evenodd'
          d='M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z'
          fill={color} />
  </svg>
)

export default TimeIcon
